var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61515 0.825195H8.86515C8.97626 0.825195 9.03182 0.880751 9.03182 0.991862V15.6585C9.03182 15.7696 8.97626 15.8252 8.86515 15.8252H7.61515C7.50404 15.8252 7.44849 15.7696 7.44849 15.6585V0.991862C7.44849 0.880751 7.50404 0.825195 7.61515 0.825195Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5736 7.53345C15.6847 7.53345 15.7402 7.589 15.7402 7.70011V8.95011C15.7402 9.06122 15.6847 9.11678 15.5736 9.11678H0.906901C0.79579 9.11678 0.740234 9.06122 0.740234 8.95011V7.70011C0.740234 7.589 0.79579 7.53345 0.906901 7.53345H15.5736Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.8582a765eea197329f2192798cd70fc9.svg";
export { ForwardRef as ReactComponent };